import PropTypes from 'prop-types'
import { useMemo, useState } from 'react'
import classNames from 'classnames'
import {
  AdHeadText,
  AdSublink,
  AdThumb,
  AssetClassNames,
  Ktalk,
  LayerMultiThumbnail,
  ListPay,
  ListThumb,
} from 'features/creative/preview/PreviewParts'
import { Assets } from 'features/Codes'
import {
  getLandingUrlState,
  stripKeywordTag,
} from 'features/creative/creativeUtil'
import SiteUrlPropTypes from '../../channel/SiteUrlPropTypes'

const BasicPreview = ({
  siteUrl,
  channel,
  basic,
  type,
  data,
  isMobileView,
}) => {
  const [isMouseOver, setMouseOver] = useState(false)
  const { individual, mobileUrl, pcUrl } = getLandingUrlState({
    individualSettingYn: siteUrl
      ? siteUrl.individualSettingYn
      : channel?.siteUrl.individualSettingYn,
    mobileLandingUrl: siteUrl ? siteUrl.mobileUrl : channel?.siteUrl.mobileUrl,
    pcLandingUrl: siteUrl ? siteUrl.pcUrl : channel?.siteUrl.pcUrl,
  })
  const viewUrl = useMemo(() => {
    if (individual) {
      if (isMobileView) {
        return mobileUrl || pcUrl || 'http://m.daum.net'
      } else {
        return pcUrl || mobileUrl || 'http://www.daum.net'
      }
    } else {
      return pcUrl || mobileUrl || 'http://www.daum.net'
    }
  }, [isMobileView, individual, pcUrl, mobileUrl])

  return (
    <>
      <div
        className={classNames(
          'material_default',
          AssetClassNames[type]?.className
        )}>
        <div className="inner_cont">
          <strong className="ad_subject">
            {stripKeywordTag(basic.title) || '제목'}
          </strong>
          {type === Assets.SUBJECT.name && isMobileView && (
            <AdHeadText {...data} />
          )}
          <div className="ad_link">
            {isMobileView && <span className="ico_ad">광고</span>}
            <span className="txt_link">{viewUrl}</span>
          </div>
          {type === Assets.SUBJECT.name && !isMobileView && (
            <AdHeadText {...data} />
          )}
          {type === Assets.ADDITIONAL_TITLE.name && (
            <p className="ad_subtxt">{data.text || '추가제목'}</p>
          )}
          {type === Assets.ADDITIONAL_LINK.name && <AdSublink {...data} />}
          <div className="ad_info">
            <span
              className={classNames('ad_desc', {
                ad_hospital: basic.licenseNumber,
              })}>
              {stripKeywordTag(basic.description) || '설명문구'}
              {basic.licenseNumber && !isMobileView && <>&nbsp;</>}
            </span>
            {basic.licenseNumber && (
              <span className="ad_set">{basic.licenseNumber}</span>
            )}
          </div>
          {type === Assets.TALK_CHANNEL.name && <Ktalk />}
          {type === Assets.PRICE_TABLE.name && (
            <ListPay priceTables={data.priceTables} />
          )}
          {type === Assets.MULTI_THUMBNAIL.name && !isMobileView && (
            <AdThumb
              url={data.images[0].url}
              alt={data.images[0].alt}
              setMouseOver={setMouseOver}
              width={64}
              thumbInfo
            />
          )}
          {type === Assets.CALCULATE.name && (
            <div className="ad_btn">
              <span className="ico_btn ico_sum">계산하기</span>
            </div>
          )}
          {type === Assets.PHONE_NUMBER.name && (
            <div className="ad_btn">
              <span className="ico_btn ico_tel">전화하기</span>
            </div>
          )}
        </div>
        {type === Assets.THUMBNAIL.name && (
          <AdThumb
            url={data.image.url}
            alt={data.image.alt}
            width={isMobileView ? 90 : 64}
          />
        )}
        {type === Assets.MULTI_THUMBNAIL.name && isMobileView && (
          <ListThumb thumbnails={data.images} />
        )}
      </div>
      {type === Assets.MULTI_THUMBNAIL.name && !isMobileView && (
        <LayerMultiThumbnail
          thumbnails={data.images}
          isMouseOver={isMouseOver}
          setMouseOver={setMouseOver}
        />
      )}
    </>
  )
}

export default BasicPreview

BasicPreview.propTypes = {
  basic: PropTypes.object,
  siteUrl: SiteUrlPropTypes,
  channel: PropTypes.object,
  data: PropTypes.object,
  type: PropTypes.string,
  isMobileView: PropTypes.bool,
}
